import React, { useContext,useEffect, useState} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import { ThemeContext } from './contexts/ThemeContext';
import { Main, BlogPage, ProjectPage } from './pages'
import { BackToTop } from './components'
import ScrollToTop from './utils/ScrollToTop';
import ReactLoading from 'react-loading';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore/lite';
import ClipLoader from "react-spinners/ClipLoader";

import './App.css'

function App() {
   const [user, setUser] = useState(null); // Pour stocker l'utilisateur récupéré
   const [error, setError] = useState(null); // Pour stocker les erreurs
   const { theme } = useContext(ThemeContext);
  
   const override: CSSProperties = {
	  display: "block",
	  margin: "0 auto",
	  borderColor: "red",
	};
	  
   const firebaseConfig = {
    apiKey: "AIzaSyCPzjFyqtOUfjuv0RGotHDiiqfLIfNMxfY",
    authDomain: "materialx-9be3b.firebaseapp.com",
    databaseURL: "https://materialx-9be3b.firebaseio.com",
    projectId: "materialx-9be3b",
    storageBucket: "materialx-9be3b.appspot.com",
    messagingSenderId: "977422050142",
    appId: "1:977422050142:web:faaa96ca2e34460561a5cf"
  };

  // Initialisation de Firebase
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  let a=1;
  // Fonction pour récupérer l'utilisateur
  const getUser = async (db, email = "equerrestudio23@gmail.com") => {
    try {
      console.log("Début de la récupération des données pour l'utilisateur:", email);
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const data = userDoc.data();
        console.log("Données utilisateur récupérées:", data);
        setUser(data); // Mise à jour du state avec les données de l'utilisateur
      } else {
        setError("Utilisateur non trouvé !");
        console.log("Aucun utilisateur trouvé pour cet email.");
      }
    } catch (error) {
      setError("Erreur lors de la récupération de l'utilisateur : " + error.message);
      console.log("Erreur lors de la récupération:", error);
    }
  };
  
  // Utilisation de useEffect pour charger les données à l'initialisation
  useEffect(() => {
    getUser(db); // Appel de la fonction lors du chargement du composant
  }, [db]);

  console.log("%cDEVELOPER PORTFOLIO", `color:${theme.primary}; font-size:50px`);
  console.log("%chttps://github.com/hhhrrrttt222111/developer-portfolio", `color:${theme.tertiary}; font-size:20px`);
  // console.log = console.warn = console.error = () => {};
  
  return (
    <div className="app">
	{ user ?(
      <Router>
        <ScrollToTop/>
        <Switch>
          <Route
			  path="/"
			  exact
			  render={(props) => <Main {...props} userData={user} />}
			/>
          <Route path="/blog" exact component={BlogPage} />
		  <Route
			  path="/projects"
			  exact
			  render={(props) => <ProjectPage {...props} projets={user.projects} />}
			/>
         
          <Redirect to="/" />
        </Switch>
      </Router>):(
	     <ClipLoader
        color="yellow"
        loading={true}
        cssOverride={override}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
	)}
      <BackToTop />
    </div>
  );
}

export default App;
